import React from 'react'

const Comittee = () => {
  return (
    <div>Comittee</div>
  )
}

export default Comittee